import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constant/Constant';
import LogoutConstant from '../../MainFrame/constants/Constants';
import restClient from '../../MainFrame/action/APIClient';

var GetCustomNavigationAction = function () {

}


GetCustomNavigationAction.prototype = {

    getCustomNavigation: function (domain) {

        restClient.getCustomNav(domain, function (error, response) {
            if (error) {
                if (error.status === 401) {
                    AppDispatcher.dispatch({
                        actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
                        data: error
                    });
                }
                else {
                    AppDispatcher.dispatch({
                        actionType: Constant.GET_INTEGRATION_CONTROL,
                        data: error
                    });
                }
            } else if(response != null) {
                response['status'] = 200;
                AppDispatcher.dispatch({
                    actionType: Constant.GET_CUSTOM_NAVIGATION,
                    data: response
                });
            }
        })
    }
}

export default new GetCustomNavigationAction();